import { Action } from 'shared/store/types';
import actions from './actionTypes';
import { AuthState } from './types';

export const defaultState = {
  fetching: false,
  dataFetched: false,
  isFetchingError: false,
  fetchedOverNetwork: false,
  cartProductQuantities: {} as Record<string, number>,
  user: {
    cartItemsCount: 0,
    email: '',
    firstName: '',
    formKey: '',
    groupId: '',
    id: '',
    isLoyal: false,
    isPro: false,
    lastName: '',
    rewardPoints: 0,
    userName: '',
    wishlist: [],
    priveBand: null,
    isRepeatUser: false,
    iocValue: null,
    pinCode: null,
    paidEarlyAccess: null,
    geoLat: null,
    geoLong: null,
  },
};

const authReducer = (state = defaultState, action: Action): AuthState => {
  const { type, payload } = action;

  switch (type) {
    case actions.FETCH_AUTH_DATA_PROGRESS:
      return {
        ...state,
        fetching: true,
        isFetchingError: false,
      };

    case actions.FETCH_AUTH_DATA_FAILED:
      return {
        ...state,
        fetching: false,
        isFetchingError: true,
      };

    case actions.FETCH_AUTH_DATA_SUCCESS:
      return {
        ...state,
        fetching: false,
        isFetchingError: false,
        dataFetched: true,
        fetchedOverNetwork: payload.fetchedOverNetwork,
        user: {
          ...state.user,
          ...payload.data, // FIXME: extract specific keys
        },
      };

    case actions.AUTH_CART_COUNT:
      return {
        ...state,
        user: {
          ...state.user,
          cartItemsCount: payload,
        },
      };

    case actions.AUTH_CART_PRODUCT_QTY_UPDATE: {
      const quantities = (payload || {}) as Record<string, number>;
      const total = Object.values(quantities).reduce(
        (a: number, b: number) => a + b,
        0
      );
      return {
        ...state,
        cartProductQuantities: quantities,
        user: {
          ...state.user,
          cartItemsCount: total,
        },
      };
    }

    case actions.SET_IOC_VALUE: {
      return {
        ...state,
        user: {
          ...state.user,
          iocValue: payload,
        },
      };
    }

    case actions.AUTH_WISHLIST_ADD:
      if (payload) {
        const isItemInWishlist = state.user.wishlist.some(
          (itemId) => itemId === payload
        );

        if (!isItemInWishlist) {
          return {
            ...state,
            user: {
              ...state.user,
              wishlist: [...state.user.wishlist, payload],
            },
          };
        }
      }
      return state;

    case actions.AUTH_WISHLIST_REMOVE:
      if (payload) {
        const filteredWishlist = state.user.wishlist.filter(
          (itemId) => itemId !== payload
        );

        return {
          ...state,
          user: {
            ...state.user,
            wishlist: filteredWishlist,
          },
        };
      }
      return state;

    case actions.WISHLIST_IDS_UPDATE:
      return {
        ...state,
        user: {
          ...state.user,
          wishlist: payload,
        },
      };

    case actions.LOGOUT:
      return {
        ...state,
        user: { ...defaultState.user },
        cartProductQuantities: {},
      };

    case actions.WISHLIST_ITEMS_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          wishlist: payload,
        },
      };
    case actions.USER_DETAILS_FETCHED:
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
        },
      };
    default:
      return state;
  }
};

export default authReducer;
